export default class ProgressBar {
	constructor($root) {
		this.$root = $root;
		this.$bar = this.$root.querySelector('.progress-bar');
		this.$barFiller = this.$bar.querySelector('.progress-bar_fill');
		this.questionsNum = 0;
		this.currentQuestionIndex = 0;
	}

	init(questionsNum, currentQuestionIndex) {
		this.questionsNum = questionsNum;
		this.currentQuestionIndex = currentQuestionIndex;
		setTimeout(() => {
			this.next(this.currentQuestionIndex);
		}, 5);
	}

	next(currentQuestionIndex) {
		this.currentQuestionIndex = currentQuestionIndex;
		this.changeProgress();
	}

	changeProgress() {
		const totalWidth = this.$bar.offsetWidth;
		const stepWidth = totalWidth / this.questionsNum;
		const currentWidth = stepWidth * this.currentQuestionIndex;
		this.$barFiller.style.transform = `translateX(${currentWidth}px)`;
	}
}